// Libraries
import { ReactNode } from 'react';

// Styles
import styles from './Lead.module.css';

/**
 * @function Lead
 * Leading paragraph(s)
 *
 * @example
 * return (
 *   <Lead></Lead>
 * )
 */
function Lead({ children = <></> }: LeadProps): JSX.Element {
    return <p className={styles.lead}>{children}</p>;
}

/**
 * @interface LeadProps
 * Describes the properties required for the Lead component
 *
 * @property {ReactNode} text Contents of message before Lead
 */
export interface LeadProps {
    children?: ReactNode;
}

// Exports
export default Lead;
